<template>
	<div>
		<NavHeader/>





		<div class="divider"></div>


		<div class="container">
			<div class="rate-detail">
				<h3>Today's Rates
					<br> For Personal Payments</h3>

				<div class="selection hidden">
					<form action="/action_page.php">
						<div class="form-check-inline">
							<label class="form-check-label" for="radio1">
								<input type="radio" class="form-check-input" id="radio1" name="optradio" value="option1" checked>MYR to FCY
							</label>
						</div>
						<div class="form-check-inline">
							<label class="form-check-label" for="radio2">
								<input type="radio" class="form-check-input" id="radio2" name="optradio" value="option2">FCY to MYR
							</label>
						</div>
					</form>
				</div>
				<!-- eo selection -->

				<div class="main-table no-border-radius">

					<div class="table-responsive-md">
						<table class="table table-striped">

							<tbody class="">
								<tr :key="rate.ExchangeRateId" v-for="rate in vModel.Rates">
									<th class="country-list">
										<img :src="'/static/flags/'+rate.FlagCode+'.png'" alt="">{{rate.CountryName}}</th>
									<td>{{rate.PayoutMode}}</td>
									<td>1.00 MYR</td>
									<td class="amount">{{rate.ExchangeRate}} {{rate.CurrencyCode}}</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				<!-- eo main table -->

			</div>
		</div>

		<div class="divider"></div>


		<div class="container">
			<div class="otherrates">
				<hr>
				<router-link :to="'/rate'" class="main-btn text-uppercase">View All Rates <i class="fas fa-angle-right"></i></router-link>

				<!-- <a href="" class="main-btn text-uppercase">View All Rates
					<i class="fas fa-angle-right"></i>
				</a> -->

				<div class="notes">
					<p class="note">Last Updated {{vModel.LastUpdateOn}}</p>
					<p class="note">Disclaimer: Rates displayed are indicative for the day and subject to change without prior notice.</p>
					<p class="note">For business rates, please contact <a href="mailto:bizcare@eremit.com.my">bizcare@eremit.com.my</a></p>
				</div>
			</div>
		</div>


		<div class="divider"></div>


		<DownloadApp/>

		<SignUpFooter/>
	</div>
</template>
<script>
	import DownloadApp from "../../shared/commercial/DownloadApp.vue";
	import NavHeader from "../../shared/commercial/NavHeader.vue";
	import SignUpFooter from "../../shared/commercial/SignUpFooter.vue";
	import ListService from "../../services/list";

	export default {
		name: "Dashboard",
		components: { DownloadApp, NavHeader, SignUpFooter },
		beforeRouteEnter(to, from, next) {
			Promise.all([
				ListService.get("list/exchangerate")
			]).then(responses => {
				next(vm => {
					vm.vModel.Rates = responses[0].body;
					vm.vModel.LastUpdateOn = vm.vModel.Rates[0].UpdatedDate
				});
			});
		},
		created() { },
		data() {
			return {
				vModel: {
					Rates: null,
					LastUpdateOn: null
				}
			};
		},
		methods: {}
	};
</script>